export default "__VITE_ASSET__Czr4v_S7__"